export const PROTOCOL_VERSION = 1;

export enum MessageType {
  // Handshake
  HELLO = 'HELLO',
  HELLO_ACK = 'HELLO_ACK',

  // Game → Host Events
  FRAMES_STARTED = 'FRAMES_STARTED',
  GAME_READY = 'GAME_READY',
  PROGRESS_SAVE = 'PROGRESS_SAVE',
  PURCHASE_REQUEST = 'PURCHASE_REQUEST',

  // Host → Game Commands
  SET_MUTE = 'SET_MUTE',
  SET_LOCALE = 'SET_LOCALE',
  SET_AD_FREE = 'SET_AD_FREE',
  PAUSE = 'PAUSE',
  RESUME = 'RESUME',
  PURCHASE_RESULT = 'PURCHASE_RESULT',

  // Sates
  SYNC_REQUEST = 'SYNC_REQUEST',
  SYNC_RESPONSE = 'SYNC_RESPONSE',
  PROGRESS_REQUEST = 'PROGRESS_REQUEST',
  PROGRESS_RESPONSE = 'PROGRESS_RESPONSE',

  // Errors
  ERROR = 'ERROR',
}

export enum ConnectionState {
  INIT = 'INIT',
  CONNECTING = 'CONNECTING',
  CONNECTED = 'CONNECTED',
  DISCONNECTED = 'DISCONNECTED',
}

export interface SDKStateData {
  muted: boolean;
  paused: boolean;
  adFree: boolean;
  locale: string;
}

export type StateChangeListener<K extends keyof SDKStateData> = (
  value: SDKStateData[K],
  oldValue: SDKStateData[K],
) => void;

export interface Message<T = unknown> {
  v: number; // версия протокола
  type: MessageType;
  id: string; // UUID сообщения
  replyTo?: string; // ID сообщения, на которое отвечаем
  ts: number; // timestamp
  payload: T;
}

export interface HelloPayload {
  role: 'host' | 'game';
}

export interface SetMutePayload {
  muted: boolean;
}

export interface SetLocalePayload {
  locale: string;
}

export interface SetAdFreePayload {
  adFree: boolean;
}

export interface PurchaseRequestPayload {
  requestId: string;
  itemId: string;
  priceInCoins: number;
  payload?: Record<string, unknown>;
}

export interface PurchaseResultPayload {
  requestId: string;
  status: 'SUCCESS' | 'FAILED' | 'INSUFFICIENT_FUNDS' | 'CANCELLED';
  balanceAfter?: number;
  error?: string;
}

export interface SyncPayload {
  progress: Record<string, unknown>;
  state: Partial<SDKStateData>;
  syncedAt: number;
}

export interface ProgressPayload {
  progress: Record<string, unknown>;
  syncedAt: number;
}

export type AnyMessage = Message;
